import { buildReferralFormSchema } from '../../../../../common';
import { REFERRAL_TEXT_MIN_LENGTH } from './constants';

export const REFERRAL_FORM_SCHEMA = buildReferralFormSchema({
  providerNameMinLength: REFERRAL_TEXT_MIN_LENGTH,
});
